import { createCategoryType } from './create'
import { deleteCategoryType } from './delete'
import { readCategoryType, readCategoryTypes } from './read'
import { updateCategoryType } from './update'

export const categoryTypes = {
  create: createCategoryType,
  readCollection: readCategoryTypes,
  readSingle: readCategoryType,
  update: updateCategoryType,
  delete: deleteCategoryType,
}
